import { render } from "./AssignmentDialog.vue?vue&type=template&id=1239613c&scoped=true"
import script from "./AssignmentDialog.vue?vue&type=script&lang=js"
export * from "./AssignmentDialog.vue?vue&type=script&lang=js"

import "./AssignmentDialog.vue?vue&type=style&index=0&id=1239613c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1239613c"]])

export default __exports__